/**
 * Belfiore code (chars 12-15 of an Italian tax code) to ISO 3166-1 alpha-2 country code.
 * Mirrors the backend map in bx-main lib/v2/tax-code/constants/belfiore-nation-collection.const.ts [BK-1236].
 *
 * Multi-successor historical states (USSR, Yugoslavia, ...), ISTAT aggregate pseudo-states and
 * territories missing from baseNationCollection are intentionally absent: decoding falls back
 * to the name-based match and, ultimately, to the Italian default.
 */
export const belfioreNationCollection = [
  { belfioreCode: "Z100", countryCode: "AL" },
  { belfioreCode: "Z101", countryCode: "AD" },
  { belfioreCode: "Z102", countryCode: "AT" },
  { belfioreCode: "Z103", countryCode: "BE" },
  { belfioreCode: "Z104", countryCode: "BG" },
  { belfioreCode: "Z106", countryCode: "VA" },
  { belfioreCode: "Z107", countryCode: "DK" },
  { belfioreCode: "Z108", countryCode: "FO" },
  { belfioreCode: "Z109", countryCode: "FI" },
  { belfioreCode: "Z110", countryCode: "FR" },
  { belfioreCode: "Z111", countryCode: "DE" }, // historical: GERMANIA REPUBBLICA DEMOCRATICA
  { belfioreCode: "Z112", countryCode: "DE" },
  { belfioreCode: "Z113", countryCode: "GI" },
  { belfioreCode: "Z114", countryCode: "GB" },
  { belfioreCode: "Z115", countryCode: "GR" },
  { belfioreCode: "Z116", countryCode: "IE" },
  { belfioreCode: "Z117", countryCode: "IS" },
  { belfioreCode: "Z119", countryCode: "LI" },
  { belfioreCode: "Z120", countryCode: "LU" },
  { belfioreCode: "Z121", countryCode: "MT" },
  { belfioreCode: "Z122", countryCode: "IM" },
  { belfioreCode: "Z123", countryCode: "MC" },
  { belfioreCode: "Z125", countryCode: "NO" },
  { belfioreCode: "Z126", countryCode: "NL" },
  { belfioreCode: "Z127", countryCode: "PL" },
  { belfioreCode: "Z128", countryCode: "PT" },
  { belfioreCode: "Z129", countryCode: "RO" },
  { belfioreCode: "Z130", countryCode: "SM" },
  { belfioreCode: "Z131", countryCode: "ES" },
  { belfioreCode: "Z132", countryCode: "SE" },
  { belfioreCode: "Z133", countryCode: "CH" },
  { belfioreCode: "Z134", countryCode: "HU" },
  { belfioreCode: "Z136", countryCode: "GE" },
  { belfioreCode: "Z137", countryCode: "AM" },
  { belfioreCode: "Z138", countryCode: "UA" },
  { belfioreCode: "Z139", countryCode: "BY" },
  { belfioreCode: "Z140", countryCode: "MD" },
  { belfioreCode: "Z141", countryCode: "AZ" },
  { belfioreCode: "Z142", countryCode: "KG" },
  { belfioreCode: "Z143", countryCode: "UZ" },
  { belfioreCode: "Z144", countryCode: "EE" },
  { belfioreCode: "Z145", countryCode: "LV" },
  { belfioreCode: "Z146", countryCode: "LT" },
  { belfioreCode: "Z147", countryCode: "TJ" },
  { belfioreCode: "Z148", countryCode: "MK" },
  { belfioreCode: "Z149", countryCode: "HR" },
  { belfioreCode: "Z150", countryCode: "SI" },
  { belfioreCode: "Z151", countryCode: "TM" },
  { belfioreCode: "Z152", countryCode: "KZ" },
  { belfioreCode: "Z153", countryCode: "BA" },
  { belfioreCode: "Z154", countryCode: "RU" },
  { belfioreCode: "Z155", countryCode: "SK" },
  { belfioreCode: "Z156", countryCode: "CZ" },
  { belfioreCode: "Z158", countryCode: "RS" },
  { belfioreCode: "Z159", countryCode: "ME" },
  { belfioreCode: "Z160", countryCode: "XK" },
  { belfioreCode: "Z161", countryCode: "PS" },
  { belfioreCode: "Z200", countryCode: "AF" },
  { belfioreCode: "Z201", countryCode: "YE" }, // historical: ARABIA MERIDIONALE FEDERAZIONE
  { belfioreCode: "Z202", countryCode: "YE" }, // historical: ARABIA MERIDIONALE PROTETTORATO
  { belfioreCode: "Z203", countryCode: "SA" },
  { belfioreCode: "Z204", countryCode: "BH" },
  { belfioreCode: "Z205", countryCode: "BT" },
  { belfioreCode: "Z206", countryCode: "MM" },
  { belfioreCode: "Z207", countryCode: "BN" },
  { belfioreCode: "Z208", countryCode: "KH" },
  { belfioreCode: "Z209", countryCode: "LK" }, // historical: CEYLON
  { belfioreCode: "Z210", countryCode: "CN" },
  { belfioreCode: "Z211", countryCode: "CY" },
  { belfioreCode: "Z213", countryCode: "KR" },
  { belfioreCode: "Z214", countryCode: "KP" },
  { belfioreCode: "Z215", countryCode: "AE" },
  { belfioreCode: "Z216", countryCode: "PH" },
  { belfioreCode: "Z217", countryCode: "TW" },
  { belfioreCode: "Z218", countryCode: "PS" },
  { belfioreCode: "Z219", countryCode: "JP" },
  { belfioreCode: "Z220", countryCode: "JO" },
  { belfioreCode: "Z222", countryCode: "IN" },
  { belfioreCode: "Z223", countryCode: "ID" },
  { belfioreCode: "Z224", countryCode: "IR" },
  { belfioreCode: "Z225", countryCode: "IQ" },
  { belfioreCode: "Z226", countryCode: "IL" },
  { belfioreCode: "Z227", countryCode: "KW" },
  { belfioreCode: "Z228", countryCode: "LA" },
  { belfioreCode: "Z229", countryCode: "LB" },
  { belfioreCode: "Z230", countryCode: "MY" },
  { belfioreCode: "Z232", countryCode: "MV" },
  { belfioreCode: "Z233", countryCode: "MN" },
  { belfioreCode: "Z234", countryCode: "NP" },
  { belfioreCode: "Z235", countryCode: "OM" },
  { belfioreCode: "Z236", countryCode: "PK" },
  { belfioreCode: "Z237", countryCode: "QA" },
  { belfioreCode: "Z238", countryCode: "JP" }, // historical: RYUKYU (ISOLE)
  { belfioreCode: "Z239", countryCode: "IN" }, // historical: SIKKIM
  { belfioreCode: "Z240", countryCode: "SY" },
  { belfioreCode: "Z241", countryCode: "TH" },
  { belfioreCode: "Z242", countryCode: "TL" },
  { belfioreCode: "Z243", countryCode: "TR" },
  { belfioreCode: "Z244", countryCode: "VN" }, // historical: VIETNAM DEL SUD
  { belfioreCode: "Z245", countryCode: "VN" }, // historical: VIETNAM DEL NORD
  { belfioreCode: "Z246", countryCode: "YE" },
  { belfioreCode: "Z247", countryCode: "MY" },
  { belfioreCode: "Z248", countryCode: "SG" },
  { belfioreCode: "Z249", countryCode: "BD" },
  { belfioreCode: "Z250", countryCode: "YE" }, // historical: YEMEN REPUBBLICA DEMOCRATICA POPOLARE
  { belfioreCode: "Z251", countryCode: "VN" },
  { belfioreCode: "Z252", countryCode: "AM" },
  { belfioreCode: "Z253", countryCode: "AZ" },
  { belfioreCode: "Z254", countryCode: "GE" },
  { belfioreCode: "Z255", countryCode: "KZ" },
  { belfioreCode: "Z256", countryCode: "KG" },
  { belfioreCode: "Z257", countryCode: "TJ" },
  { belfioreCode: "Z258", countryCode: "TM" },
  { belfioreCode: "Z259", countryCode: "UZ" },
  { belfioreCode: "Z300", countryCode: "NA" },
  { belfioreCode: "Z301", countryCode: "DZ" },
  { belfioreCode: "Z302", countryCode: "AO" },
  { belfioreCode: "Z303", countryCode: "LS" }, // historical: BASUTOLAND-SUD AFRICA BRITANNICO
  { belfioreCode: "Z304", countryCode: "BW" }, // historical: BECIUANIA-SUD AFRICA BRITANNICO
  { belfioreCode: "Z305", countryCode: "BI" },
  { belfioreCode: "Z306", countryCode: "CM" },
  { belfioreCode: "Z307", countryCode: "CV" },
  { belfioreCode: "Z308", countryCode: "CF" },
  { belfioreCode: "Z309", countryCode: "TD" },
  { belfioreCode: "Z310", countryCode: "KM" },
  { belfioreCode: "Z311", countryCode: "CG" },
  { belfioreCode: "Z312", countryCode: "CD" },
  { belfioreCode: "Z313", countryCode: "CI" },
  { belfioreCode: "Z314", countryCode: "BJ" }, // historical: BENIN
  { belfioreCode: "Z315", countryCode: "ET" },
  { belfioreCode: "Z316", countryCode: "GA" },
  { belfioreCode: "Z317", countryCode: "GM" },
  { belfioreCode: "Z318", countryCode: "GH" },
  { belfioreCode: "Z319", countryCode: "GN" },
  { belfioreCode: "Z320", countryCode: "GW" },
  { belfioreCode: "Z321", countryCode: "GQ" },
  { belfioreCode: "Z322", countryCode: "KE" },
  { belfioreCode: "Z323", countryCode: "MA" }, // historical: IFNI
  { belfioreCode: "Z325", countryCode: "LR" },
  { belfioreCode: "Z326", countryCode: "LY" },
  { belfioreCode: "Z327", countryCode: "MG" },
  { belfioreCode: "Z328", countryCode: "MW" },
  { belfioreCode: "Z329", countryCode: "ML" },
  { belfioreCode: "Z330", countryCode: "MA" },
  { belfioreCode: "Z331", countryCode: "MR" },
  { belfioreCode: "Z332", countryCode: "MU" },
  { belfioreCode: "Z333", countryCode: "MZ" },
  { belfioreCode: "Z334", countryCode: "NE" },
  { belfioreCode: "Z335", countryCode: "NG" },
  { belfioreCode: "Z336", countryCode: "EG" },
  { belfioreCode: "Z337", countryCode: "ZW" }, // historical: RHODESIA
  { belfioreCode: "Z338", countryCode: "RW" },
  { belfioreCode: "Z339", countryCode: "EH" }, // historical: SAHARA SPAGNOLO
  { belfioreCode: "Z340", countryCode: "SH" },
  { belfioreCode: "Z341", countryCode: "ST" },
  { belfioreCode: "Z342", countryCode: "SC" },
  { belfioreCode: "Z343", countryCode: "SN" },
  { belfioreCode: "Z344", countryCode: "SL" },
  { belfioreCode: "Z345", countryCode: "SO" },
  { belfioreCode: "Z346", countryCode: "DJ" }, // historical: SOMALIA FRANCESE
  { belfioreCode: "Z347", countryCode: "ZA" },
  { belfioreCode: "Z348", countryCode: "SD" },
  { belfioreCode: "Z349", countryCode: "SZ" }, // historical: SWAZILAND
  { belfioreCode: "Z350", countryCode: "TZ" }, // historical: TANGANICA
  { belfioreCode: "Z351", countryCode: "TG" },
  { belfioreCode: "Z352", countryCode: "TN" },
  { belfioreCode: "Z353", countryCode: "UG" },
  { belfioreCode: "Z354", countryCode: "BF" },
  { belfioreCode: "Z355", countryCode: "ZM" },
  { belfioreCode: "Z356", countryCode: "TZ" }, // historical: ZANZIBAR
  { belfioreCode: "Z357", countryCode: "TZ" },
  { belfioreCode: "Z358", countryCode: "BW" },
  { belfioreCode: "Z359", countryCode: "LS" },
  { belfioreCode: "Z361", countryCode: "DJ" },
  { belfioreCode: "Z364", countryCode: "ZA" }, // historical: BOPHUTHATSWANA
  { belfioreCode: "Z365", countryCode: "ZA" }, // historical: TRANSKEI
  { belfioreCode: "Z366", countryCode: "ZA" }, // historical: VENDA
  { belfioreCode: "Z367", countryCode: "ZA" }, // historical: CISKEI
  { belfioreCode: "Z368", countryCode: "ER" },
  { belfioreCode: "Z400", countryCode: "BM" },
  { belfioreCode: "Z401", countryCode: "CA" },
  { belfioreCode: "Z402", countryCode: "GL" },
  { belfioreCode: "Z403", countryCode: "PM" },
  { belfioreCode: "Z404", countryCode: "US" },
  { belfioreCode: "Z502", countryCode: "BS" },
  { belfioreCode: "Z503", countryCode: "CR" },
  { belfioreCode: "Z504", countryCode: "CU" },
  { belfioreCode: "Z505", countryCode: "DO" },
  { belfioreCode: "Z506", countryCode: "SV" },
  { belfioreCode: "Z507", countryCode: "JM" },
  { belfioreCode: "Z509", countryCode: "GT" },
  { belfioreCode: "Z510", countryCode: "HT" },
  { belfioreCode: "Z511", countryCode: "HN" },
  { belfioreCode: "Z512", countryCode: "BZ" },
  { belfioreCode: "Z514", countryCode: "MX" },
  { belfioreCode: "Z515", countryCode: "NI" },
  { belfioreCode: "Z516", countryCode: "PA" },
  { belfioreCode: "Z517", countryCode: "PA" }, // historical: PANAMA ZONA DEL CANALE
  { belfioreCode: "Z519", countryCode: "TC" },
  { belfioreCode: "Z522", countryCode: "BB" },
  { belfioreCode: "Z524", countryCode: "GD" },
  { belfioreCode: "Z525", countryCode: "VG" },
  { belfioreCode: "Z526", countryCode: "DM" },
  { belfioreCode: "Z527", countryCode: "LC" },
  { belfioreCode: "Z528", countryCode: "VC" },
  { belfioreCode: "Z529", countryCode: "AI" },
  { belfioreCode: "Z530", countryCode: "KY" },
  { belfioreCode: "Z531", countryCode: "MS" },
  { belfioreCode: "Z532", countryCode: "AG" },
  { belfioreCode: "Z533", countryCode: "KN" },
  { belfioreCode: "Z600", countryCode: "AR" },
  { belfioreCode: "Z601", countryCode: "BO" },
  { belfioreCode: "Z602", countryCode: "BR" },
  { belfioreCode: "Z603", countryCode: "CL" },
  { belfioreCode: "Z604", countryCode: "CO" },
  { belfioreCode: "Z605", countryCode: "EC" },
  { belfioreCode: "Z606", countryCode: "GY" }, // historical: GUYANA
  { belfioreCode: "Z608", countryCode: "SR" },
  { belfioreCode: "Z609", countryCode: "FK" },
  { belfioreCode: "Z610", countryCode: "PY" },
  { belfioreCode: "Z611", countryCode: "PE" },
  { belfioreCode: "Z612", countryCode: "TT" },
  { belfioreCode: "Z613", countryCode: "UY" },
  { belfioreCode: "Z614", countryCode: "VE" },
  { belfioreCode: "Z700", countryCode: "AU" },
  { belfioreCode: "Z703", countryCode: "CK" },
  { belfioreCode: "Z704", countryCode: "FJ" },
  { belfioreCode: "Z706", countryCode: "GU" },
  { belfioreCode: "Z707", countryCode: "ID" }, // historical: IRIAN OCCIDENTALE
  { belfioreCode: "Z708", countryCode: "AU" },
  { belfioreCode: "Z709", countryCode: "JP" },
  { belfioreCode: "Z711", countryCode: "MH" },
  { belfioreCode: "Z713", countryCode: "NR" },
  { belfioreCode: "Z716", countryCode: "NC" },
  { belfioreCode: "Z717", countryCode: "VU" }, // historical: NUOVE EBRIDI (ISOLE CONDOMINIO FRANCO-INGLESE)
  { belfioreCode: "Z718", countryCode: "PG" }, // historical: NUOVA GUINEA
  { belfioreCode: "Z719", countryCode: "NZ" },
  { belfioreCode: "Z720", countryCode: "PG" }, // historical: PAPUASIA
  { belfioreCode: "Z721", countryCode: "CL" },
  { belfioreCode: "Z722", countryCode: "PN" },
  { belfioreCode: "Z723", countryCode: "PF" },
  { belfioreCode: "Z724", countryCode: "SB" },
  { belfioreCode: "Z726", countryCode: "WS" },
  { belfioreCode: "Z728", countryCode: "TO" },
  { belfioreCode: "Z729", countryCode: "WF" },
  { belfioreCode: "Z730", countryCode: "PG" },
  { belfioreCode: "Z731", countryCode: "KI" },
  { belfioreCode: "Z732", countryCode: "TV" },
  { belfioreCode: "Z733", countryCode: "VU" },
  { belfioreCode: "Z734", countryCode: "PW" },
  { belfioreCode: "Z735", countryCode: "FM" },
  { belfioreCode: "Z907", countryCode: "SS" },
];

export const belfioreToCountryCodeMap: ReadonlyMap<string, string> = new Map(
  belfioreNationCollection.map((belfioreNation) => [belfioreNation.belfioreCode, belfioreNation.countryCode])
);
